import { useState } from 'react';
import { Box, Center, Text, VStack, useColorModeValue, HStack } from '@chakra-ui/react';
import { Dropdown } from 'components/ui/Dropdown';

const DropDownPreview = () => {
  const [selectedValue1, setSelectedValue1] = useState<string | number>('');
  const [selectedValue2, setSelectedValue2] = useState<string | number>('');
  const [selectedValue3, setSelectedValue3] = useState<string | number>('');
  const [selectedValue4, setSelectedValue4] = useState<string | number>('');

  const bg = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.800', 'white');

  const basicItems = [
    { label: 'Opción 1', value: 'option1' },
    { label: 'Opción 2', value: 'option2' },
    { label: 'Opción 3', value: 'option3' },
    { label: 'Opción 4', value: 'option4' },
  ];

  const itemsWithDisabled = [
    { label: 'Activo', value: 'active' },
    { label: 'Inactivo', value: 'inactive', isDisabled: true },
    { label: 'Pendiente', value: 'pending' },
    { label: 'Archivado', value: 'archived', isDisabled: true },
  ];

  const itemsWithDanger = [
    { label: 'Editar', value: 'edit' },
    { label: 'Duplicar', value: 'duplicate' },
    { label: 'Eliminar', value: 'delete', isDanger: true },
    { label: 'Archivar', value: 'archive', isDanger: true },
  ];

  const manyItems = Array.from({ length: 20 }, (_, i) => ({
    label: `Elemento ${i + 1}`,
    value: `item-${i + 1}`,
  }));

  return (
    <Center minH="100vh" bg={bg} p="40px">
      <VStack spacing="48px" w="100%" maxW="800px">
        <Text fontSize="xl" fontWeight="700" color={textColor}>
          Dropdown — Preview
        </Text>

        <Box w="100%" h="1px" bg="gray.200" />

        {/* Dropdown 1: Básico */}
        <VStack spacing="16px" align="flex-start" w="100%">
          <Text fontSize="sm" fontWeight="700" color="gray.600">
            Dropdown básico
          </Text>
          <Dropdown
            label="Selecciona una opción"
            items={basicItems}
            onSelect={(value) => setSelectedValue1(value)}
            colorScheme="brand"
          />
          {selectedValue1 && (
            <Text fontSize="sm" color="gray.500">
              Seleccionado: {selectedValue1}
            </Text>
          )}
        </VStack>

        <Box w="100%" h="1px" bg="gray.200" />

        {/* Dropdown 2: Con items deshabilitados */}
        <VStack spacing="16px" align="flex-start" w="100%">
          <Text fontSize="sm" fontWeight="700" color="gray.600">
            Dropdown con items deshabilitados
          </Text>
          <Dropdown
            label="Estados"
            items={itemsWithDisabled}
            onSelect={(value) => setSelectedValue2(value)}
            colorScheme="blue"
          />
          {selectedValue2 && (
            <Text fontSize="sm" color="gray.500">
              Seleccionado: {selectedValue2}
            </Text>
          )}
        </VStack>

        <Box w="100%" h="1px" bg="gray.200" />

        {/* Dropdown 3: Con opciones de peligro */}
        <VStack spacing="16px" align="flex-start" w="100%">
          <Text fontSize="sm" fontWeight="700" color="gray.600">
            Dropdown con acciones peligrosas
          </Text>
          <Dropdown
            label="Acciones"
            items={itemsWithDanger}
            onSelect={(value) => setSelectedValue3(value)}
            colorScheme="orange"
          />
          {selectedValue3 && (
            <Text fontSize="sm" color="gray.500">
              Seleccionado: {selectedValue3}
            </Text>
          )}
        </VStack>

        <Box w="100%" h="1px" bg="gray.200" />

        {/* Dropdown 4: Con scroll (muchos items) */}
        <VStack spacing="16px" align="flex-start" w="100%">
          <Text fontSize="sm" fontWeight="700" color="gray.600">
            Dropdown con scroll (listMaxH)
          </Text>
          <Dropdown
            label="Selecciona un elemento"
            items={manyItems}
            onSelect={(value) => setSelectedValue4(value)}
            colorScheme="purple"
            listMaxH="200px"
          />
          {selectedValue4 && (
            <Text fontSize="sm" color="gray.500">
              Seleccionado: {selectedValue4}
            </Text>
          )}
        </VStack>

        <Box w="100%" h="1px" bg="gray.200" />

        <VStack spacing="4px" align="flex-start" w="100%">
          <Text fontSize="sm" fontWeight="600" color="gray.600">
            Props disponibles:
          </Text>
          <Text fontSize="xs" color="gray.500">
            • label: string - Texto del botón
          </Text>
          <Text fontSize="xs" color="gray.500">
            • items: DropdownItem[] - Array de opciones
          </Text>
          <Text fontSize="xs" color="gray.500">
            • onSelect: (value) =&gt; void - Callback al seleccionar
          </Text>
          <Text fontSize="xs" color="gray.500">
            • showIcon: boolean - Mostrar ícono de expansión
          </Text>
          <Text fontSize="xs" color="gray.500">
            • borderRadius: string | number - Radio de bordes
          </Text>
          <Text fontSize="xs" color="gray.500">
            • listMaxH: string | number - Altura máxima con scroll
          </Text>
          <Text fontSize="xs" color="gray.500">
            • isDanger: boolean - Colorear item en rojo
          </Text>
          <Text fontSize="xs" color="gray.500">
            • isDisabled: boolean - Deshabilitar item
          </Text>
        </VStack>
      </VStack>
    </Center>
  );
};

export default DropDownPreview;